import { Password } from '../common/Password'

import { createField } from './createField'

export const PasswordField = createField({ Component: Password })
